export default "__VITE_ASSET__BnbLH2Us__"